import { transport } from 'config/transport';

export function callApiSaveChiNoiTru(congDoanId, month, year, body) {
    return transport.post(`/noitru/${congDoanId}/thuchi/chinoitru`, body, { params: { month, year } });
}
